import React, { Fragment } from "react";
import { Grid, Box, Typography, Modal, Button } from "@material-ui/core";
import { formatLocaleDate } from "../utils/dateUtils";
import StaffRating from "./support/staff/StaffRating";
import ButtonLoader from "./ButtonLoader";
import RatingStars from "./RatingStars";
export default function RatingModal({
  modal,
  loading,
  onClose,
  modalData,
  onSuccess,
}) {
  console.log(modalData);
  return (
    <Modal
      open={modal}
      onClose={() => {
        !loading && onClose();
      }}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Box className="modal-wrapper">
        <Box className="modal">
          <div className="modal-heading">
            <div className="modal-heading-text">
              <Typography className="modal-title">評価確認</Typography>
            </div>
            <button className="back-btn" onClick={() => !loading && onClose()}>
              閉じる
            </button>
          </div>
          <div className="modal-body">
            <div>
              <Typography
                style={{
                  fontSize: "1.4rem",
                  fontWeight: "800",
                  color: "var(--primary-color)",
                }}
              >
                評価を送信します
              </Typography>
              <Box className="ratings-modal-wrapper">
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="center"
                  style={{ textAlign: "left" }}
                >
                  <Grid item md={9} container spacing={2} alignItems="center">
                    <Grid item md={"auto"}>
                      {modalData?.staffInfo?.staffNickname == "指名なし" ? (
                        <img
                          src={"/images/staff_free.png"}
                          style={{
                            height: "80px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img
                          src={
                            modalData?.staffInfo?.staffImageUrl ||
                            "/images/staff_noimage.png"
                          }
                          style={{
                            height: "80px",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </Grid>
                    <Grid item md={"auto"}>
                      <Typography style={{ marginBottom: "0" }}>
                        {modalData?.staffInfo?.staffNickname}
                      </Typography>
                      <Typography style={{ marginBottom: "0" }}>
                        {modalData?.staffInfo?.staffAge
                          ? modalData.staffInfo.staffAge + ", "
                          : ""}
                        {modalData?.staffInfo?.staffGender ? (
                          <Fragment>
                            {modalData.staffInfo.staffGender == "MALE"
                              ? "男性"
                              : "女性"}
                          </Fragment>
                        ) : (
                          ""
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item md={3}>
                    {/* <Box className="text-center">
                      <Typography style={{ fontWeight: "900" }}>TIP</Typography>
                    </Box> */}
                    <Grid
                      container
                      className="tip-wrapper"
                      style={{ marginTop: 0 }}
                    >
                      <Grid
                        item
                        md={"auto"}
                        className={
                          modalData?.ratingsData?.tip !== "no-tip"
                            ? `tip-${modalData?.ratingsData?.tip.price}`
                            : "no-tip"
                        }
                        style={{ minWidth: "auto" }}
                      >
                        <button
                          style={{
                            width: "80px",
                            height: "80px",
                            fontSize: "1rem",
                            borderWidth: "2px",
                            cursor: "default",
                          }}
                        >
                          {modalData?.ratingsData?.tip !== "no-tip" ? (
                            `¥${modalData?.ratingsData?.tip?.price}`
                          ) : (
                            <div style={{ fontWeight: "900" }}>贈らない</div>
                          )}
                        </button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              <Box>
                <Grid
                  container
                  justifyContent="center"
                  className="ratings-modal-wrapper"
                >
                  <Grid item md={12}>
                    <Grid container className={`rest-ratings show`}>
                      <Grid container className="rating-stars" item xs={12}>
                        <Grid
                          item
                          md={3}
                          sm={"auto"}
                          xs={"auto"}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Typography style={{ display: "inline-block" }}>
                            総合評価
                          </Typography>
                        </Grid>
                        <Grid item md={9} sm={12} xs={12}>
                          <RatingStars
                            initRating={
                              modalData?.ratingsData?.memberTotalScore
                            }
                            onRatingChanged={() => {}}
                            canChangeRating={false}
                            showText={false}
                          />
                        </Grid>
                      </Grid>
                      {modalData?.ratingsData?.memberDetailScore?.map(
                        (rating, id) => (
                          <Grid
                            container
                            className="rating-stars"
                            key={id}
                            item
                            xs={12}
                          >
                            <Grid
                              item
                              md={3}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <Typography>{rating.title}</Typography>
                            </Grid>
                            <Grid item md={9} sm={12} xs={12}>
                              <RatingStars
                                initRating={rating.score}
                                onRatingChanged={() => {}}
                                showText={false}
                                canChangeRating={false}
                              />
                            </Grid>
                          </Grid>
                        )
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Box>

              {modalData?.ratingsData?.ratingComment && (
                <Box className="ratings-modal-wrapper">
                  <div>
                    <Typography
                      className="text-left "
                      style={{
                        whiteSpace: "pre-line",
                        maxHeight: "190px",
                        overflowY: "auto",
                      }}
                    >
                      <Typography
                        style={{ fontWeight: 600 }}
                        component={"span"}
                      >
                        サポート対応の感想:
                      </Typography>
                      <br /> {modalData.ratingsData.ratingComment}
                    </Typography>
                  </div>
                </Box>
              )}

              {loading && <div className="button-overlay"></div>}
              <Button
                variant="contained"
                color="primary"
                style={{ padding: "6px 5rem", marginRight: "10px" }}
                disabled={loading}
                onClick={onSuccess}
              >
                {loading ? <ButtonLoader btnColor="light" /> : "確定"}
              </Button>
            </div>
          </div>
        </Box>
      </Box>
    </Modal>
  );
}
